package com.xtream.ui.ui.preference

import androidx.compose.foundation.focusGroup
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.calculateStartPadding
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.xtream.ui.data.PreferenceAction
import com.xtream.ui.data.PreferenceCategoryAction


@Composable
fun SettingsComposeScreen(
    modifier: Modifier = Modifier,
    containerColor: Color = MaterialTheme.colorScheme.background,
    title: String,
    headerContent: @Composable (() -> Unit)? = null,
    preferences: List<PreferenceAction>,
    onFocused: (PreferenceAction) -> Unit = {},
    contentPadding: PaddingValues = PaddingValues(0.dp),
    onClick: ((PreferenceAction) -> Unit)? = null,
) {
    val layoutDirection = LocalLayoutDirection.current

    // ✅ computed outside scaffold lambda — not on every recomposition
    val firstFocusIndex = remember(preferences) {
        preferences.indexOfFirst { it !is PreferenceCategoryAction }.coerceAtLeast(0)
    }

    Scaffold(
        modifier = modifier,
        containerColor = containerColor,
        topBar = {
            Text(
                modifier = Modifier
                    .padding(
                        start = contentPadding.calculateStartPadding(layoutDirection),
                        top = contentPadding.calculateTopPadding(),
                    )
                    .fillMaxWidth()
                    .padding(vertical = 24.dp),
                text = title,
                fontWeight = FontWeight.Bold,
                style = MaterialTheme.typography.titleLarge,
                textAlign = TextAlign.Start,
            )
        },

    ) { innerPadding ->
        val groupFocusRequester = remember { FocusRequester() }
        val focusRequester = remember { FocusRequester() }

        LazyColumn(
            modifier = Modifier
                .padding(innerPadding)
                .fillMaxSize()
                .focusGroup()
                .focusRequester(groupFocusRequester)
                .focusRestorer (focusRequester ), // ✅ restores to first focusable item
            contentPadding = contentPadding,
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            if (headerContent != null) {
                item { headerContent() }
            }

            itemsIndexed(
                preferences,
                // ✅ stable key — index alone causes full recomposition on reorder
                key = { index, pref -> pref.key.ifEmpty { "$index-${pref.title}" } },
            ) { index, pref ->
                GetCompatiblePrefButton(
                    action = pref,
                    modifier = Modifier
                        .then(
                            if (index == firstFocusIndex)
                                Modifier.focusRequester(focusRequester)
                            else
                                Modifier,
                        )
                        .onFocusChanged { if (it.isFocused) onFocused(pref) }
                        .fillMaxWidth(),
                    dialogsModifier = modifier,
                    onClick = onClick,
                )
            }
        }
    }
}